import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCalculator = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.464 3h7.073C17.98 3 19.5 4.725 19.5 7.165v9.67c0 2.44-1.52 4.165-3.964 4.165H8.464C6.02 21 4.5 19.275 4.5 16.835v-9.67C4.5 4.725 6.028 3 8.464 3"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.436 10.677h5.129c1 0 1.624.707 1.624 1.707v3.963c0 1-.623 1.707-1.625 1.707H9.436c-1 0-1.624-.707-1.624-1.707v-3.963c0-1 .626-1.707 1.624-1.707M15.721 13.134H8.345m0 2.462h7.376M13.28 18.054v-7.377m-2.56 0v7.377M9.438 8.074h5.136M10.654 5.806h2.704"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCalculator);
export default ForwardRef;
